module.exports = __webpack_public_path__ + "static/media/SarahSwitek_10_Questions_6.8c8f5ea0.mp3";